import { Theme } from "@components/theme/Theme";

import * as List from "../list/List";

import {
  StyledTitle,
  validateProps,
  Dropdown,
  StyledBottomLink,
} from "./FilterableList";
import { FilterableListProps } from "./types";
import { useDropdown } from "./useDropdown";

import styles from "./styles.module.css";

function WithRedTitle<IterableComponentProps>(
  props: FilterableListProps<IterableComponentProps>
) {
  const { hideFilters = false, filterFunctions, title, link } = props;

  if (!validateProps(props)) return null;

  const { componentPropsList, selectedFilter, error, handleDropdownSelect } =
    useDropdown({ filterFunctions });

  if (error) console.error(error);

  return (
    <div className={styles.filterableListContainer}>
      <div className={styles.header}>
        <Theme accentColor="red">
          <StyledTitle title={title} />
        </Theme>
        {!hideFilters && <Dropdown
          options={Object.keys(props.filterFunctions)}
          selectedFilter={selectedFilter}
          handleDropdownSelect={handleDropdownSelect}
        />}
      </div>
      <List.Component<IterableComponentProps>
        {...props}
        componentPropsList={componentPropsList}
      />
      {link && <StyledBottomLink link={link} />}
    </div>
  );
}

export { WithRedTitle };
